import React from 'react';
import { useTheme, alpha } from '@mui/material';
import {
    AreaChart, Area, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import ChartCard from './ChartCard';

const PostsOverTimeChart = ({ data, color = '#6366f1', height = 280 }) => {
    const theme = useTheme();
    const axisStyle = { stroke: theme.palette.text.secondary, fontSize: 11 };

    if (!data || data.length === 0) return null;

    // Shorten period labels for display
    const formatted = data.map(d => ({
        ...d,
        label: d.period.includes('-W')
            ? `W${d.period.split('-W')[1]}`
            : d.period,
    }));

    return (
        <ChartCard title="Posts Over Time" icon={<TrendingUpIcon />} height={height}>
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={formatted} margin={{ top: 10, right: 10, left: 0, bottom: 5 }}>
                    <defs>
                        <linearGradient id="gradViews" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={color} stopOpacity={0.2} />
                            <stop offset="95%" stopColor={color} stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="gradLikes" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#0284c7" stopOpacity={0.15} />
                            <stop offset="95%" stopColor="#0284c7" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={alpha(theme.palette.divider, 0.4)}
                        vertical={false}
                    />
                    <XAxis
                        dataKey="label"
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        dy={8}
                        interval="preserveStartEnd"
                    />
                    <YAxis
                        {...axisStyle}
                        axisLine={false}
                        tickLine={false}
                        dx={-8}
                        tickFormatter={(v) => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v}
                    />
                    <Tooltip
                        contentStyle={{
                            background: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: 12,
                            boxShadow: '0 10px 30px -10px rgba(0,0,0,0.15)',
                            fontWeight: 600,
                        }}
                        formatter={(value, name) => [value.toLocaleString(), name]}
                    />
                    <Legend wrapperStyle={{ paddingTop: 10, fontSize: 12 }} />
                    <Area
                        type="monotone"
                        dataKey="views"
                        name="Views"
                        stroke={color}
                        strokeWidth={2.5}
                        fill="url(#gradViews)"
                        dot={false}
                        activeDot={{ r: 5 }}
                    />
                    <Area
                        type="monotone"
                        dataKey="likes"
                        name="Likes"
                        stroke="#0284c7"
                        strokeWidth={2}
                        fill="url(#gradLikes)"
                        dot={false}
                        activeDot={{ r: 4 }}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};

export default PostsOverTimeChart;
